document.addEventListener('DOMContentLoaded', () => {

  const mainImage = document.getElementById('mainProductImage');

  document.querySelectorAll('.luxury-thumbnail-item')
    .forEach((thumb) => {

      thumb.addEventListener('click', () => {

        const image = thumb.dataset.image;

        if(mainImage && image){
          mainImage.src = image;
        }

      });

    });

  const qtyInput = document.querySelector('.luxury-qty-input');
  const plusBtn = document.querySelector('.qty-plus');
  const minusBtn = document.querySelector('.qty-minus');

  if(plusBtn){

    plusBtn.addEventListener('click', () => {

      qtyInput.value = parseInt(qtyInput.value || 1) + 1;

    });

  }

  if(minusBtn){

    minusBtn.addEventListener('click', () => {

      const current = parseInt(qtyInput.value || 1);

      if(current > 1){
        qtyInput.value = current - 1;
      }

    });

  }

});